import {createGiftsList, createTicketsList} from './GiftsService.mock';
import {DI_TOKENS} from '@/di/di.tokens';
import {UserGift} from '@/stores/GiftsStore/GiftsStore.types';

import {injected} from 'brandi';

import {DevPanel} from '@/services/DevPanel/DevPanel';
import {ProjectDate} from '@/services/ProjectDate/ProjectDate';
import {GiftsStore} from '@/stores/GiftsStore/GiftsStore';
import {UserStore} from '@/stores/UserStore/UserStore';
import {Config} from '@/types';

export class GiftsDevPanel {
  public isInitialized: boolean = false;
  public config: {
    ticketsCount: number;
    gifts: UserGift[];
  };

  constructor(
    private readonly gui: DevPanel,
    private readonly configApp: Config,
    private readonly giftsStore: GiftsStore,
    private readonly projectDate: ProjectDate,
    private readonly userStore: UserStore,
  ) {}

  public init = (): void => {
    if (this.configApp.isProd) {
      return;
    }
    if (this.isInitialized) {
      return;
    }
    this.isInitialized = true;
    this.config = {
      ticketsCount: this.giftsStore.getGiftTickets().tickets.length,
      gifts: [],
    };

    const folder = this.gui.getInstance().addFolder('Gifts');

    folder
      .add(this.config, 'ticketsCount')
      .onChange((count: number) => this.giftsStore.setTickets(createTicketsList(count)));

    folder
      .add(this.config, 'gifts', {
        ['Пустой массив']: [],
        ['Замоканный массив']: createGiftsList(this.projectDate),
      })
      .onChange(this.giftsStore.setGifts);
  };
}

injected(
  GiftsDevPanel,
  DI_TOKENS.devPanel,
  DI_TOKENS.config,
  DI_TOKENS.giftsStore,
  DI_TOKENS.projectDate,
  DI_TOKENS.userStore,
);
